export default function flattenFields(fields) {
  if (fields.some(c => "columns" in c)) {
    return fields.reduce((agg, f) => agg.concat(f.columns), []);
  }
  return fields;
}
